class PasProductCard extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const data = this.querySelector('[data-card-variants]');
    try { this.variants = JSON.parse(data?.textContent || '[]'); }
    catch { this.variants = []; }
    this.active = this.variants.find((variant) => String(variant.id) === this.querySelector('[data-variant-id]')?.value) || this.variants[0];
    this.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-swatch]');
      if (!swatch || !this.contains(swatch) || swatch.disabled) return;
      const next = this.variantFor(Number(swatch.dataset.optionIndex), swatch.dataset.optionValue);
      if (next) this.selectVariant(next);
    });
    this.refreshSwatches();
  }

  variantFor(optionIndex, value) {
    return window.PasVariantState?.resolve(this.variants, this.active, optionIndex, value) || null;
  }

  selectVariant(variant) {
    this.active = variant;
    const input = this.querySelector('[data-variant-id]');
    const addButton = this.querySelector('[data-add-button]');
    const price = this.querySelector('[data-price]');
    const comparePrice = this.querySelector('[data-compare-price]');
    const availability = this.querySelector('[data-availability]');
    const image = this.querySelector('.pas-card__image--primary');
    if (input) input.value = variant.id;
    if (price) price.textContent = variant.price;
    if (comparePrice) {
      comparePrice.textContent = variant.compareAt || '';
      comparePrice.hidden = !variant.compareAt;
    }
    if (availability) availability.hidden = variant.available;
    if (addButton) {
      addButton.disabled = !variant.available;
      const title = this.querySelector('.pas-card__title')?.textContent?.trim() || 'Product';
      addButton.setAttribute('aria-label', variant.available ? `Add ${title} to cart` : `${title} is sold out`);
    }
    this.querySelectorAll('[data-product-link]').forEach((link) => { link.href = variant.url; });
    const quickView = this.querySelector('[data-quick-view-trigger]');
    if (quickView) quickView.dataset.initialVariant = variant.id;
    if (image && variant.image) {
      image.removeAttribute('srcset');
      image.src = variant.image;
      image.alt = variant.imageAlt || '';
    }
    this.refreshSwatches();
    this.dispatchEvent(new CustomEvent('pas:variant-change', { bubbles: true, detail: { variant } }));
  }

  refreshSwatches() {
    this.querySelectorAll('[data-swatch]').forEach((swatch) => {
      const index = Number(swatch.dataset.optionIndex);
      const value = swatch.dataset.optionValue;
      const candidate = this.variantFor(index, value);
      const active = this.active?.options[index] === value;
      swatch.disabled = !candidate;
      swatch.classList.toggle('is-active', active);
      swatch.classList.toggle('is-unavailable', Boolean(candidate && !candidate.available));
      swatch.setAttribute('aria-pressed', String(active));
      const optionName = swatch.closest('[role="group"]')?.getAttribute('aria-label')?.replace(/ options$/, '') || 'Option';
      swatch.setAttribute('aria-label', `${optionName}: ${value}${candidate && !candidate.available ? ' (unavailable)' : candidate ? '' : ' (unavailable combination)'}`);
    });
  }
}

if (!customElements.get('pas-product-card')) customElements.define('pas-product-card', PasProductCard);
